export const GET_STAFF_LIST = "GET_STAFF_LIST";
export const ADD_STAFF = "ADD_STAFF";
export const UPDATE_STAFF = "UPDATE_STAFF";
export const DELETE_STAFF = "DELETE_STAFF";
export const GET_WORKING_HOUR = "GET_WORKING_HOUR";
export const UPDATE_WORKING_HOUR = "UPDATE_WORKING_HOUR";
export const GET_SERVICE_LIST = "GET_SERVICE_LIST";
export const GET_STAFF_SERVICE_LIST = "GET_STAFF_SERVICE_LIST";
export const ADD_SERVICE_TO_STAFF = "ADD_SERVICE_TO_STAFF";
export const REMOVE_SERVICE_FROM_STAFF = "REMOVE_SERVICE_FROM_STAFF";
export const SET_LOADING = "SET_LOADING";
export const GET_CHECKIN_STAFF = "GET_CHECKIN_STAFF";
export const UPDATE_BOOKING_STAFF = "UPDATE_BOOKING_STAFF";
export const DRAG_STAFF = "DRAG_STAFF";
export const LIST_COMMISSION_BY_STAFF = "LIST_COMMISSION_BY_STAFF";
export const CHANGE_STAFF_COMMISSION = "CHANGE_STAFF_COMMISSION";
export const UPDATE_COMMISION = "UPDATE_COMMISION";

export const GET_PERMISSION_LIST = "GET_PERMISSION_LIST";